<script setup>
import { ref, onMounted } from 'vue';
import IMask from 'imask';

const props = defineProps({
  type: { String, default: 'text' },
  name: { String, required: true },
  id: { String, required: false },
  label: { String, required: true },
  placeholder: { String, required: true },
  tooltip: String,
  value: { String, Number, required: true },
  mask: { String, Number },
  maxLength: { type: [Number, String], default: '' },
  min: { String, Number },
  max: { String, Number },
  dirty: Boolean,
  errorMessage: String,
  initialFocus: Boolean,
  autocomplete: String,
});
const input = ref(null);

onMounted(() => {
  if (props.mask) {
    IMask(input.value, {
      mask: props.mask,
      pattern: 'C',
      blocks: {
        C: {
          mask: /^.+$/,
        },
      },
    });
  }
  if (props.initialFocus) {
    input.value.focus();
  }
});
</script>

<template>
  <div class="text-field">
    <label :for="`textfield--${props.name}`">
      <span v-if="props.label">{{ props.label }}</span>
      <span
        v-if="props.tooltip"
        class="tooltip"
      >
        <p>{{ props.tooltip }}</p>
      </span>
      <input
        class="input-field"
        :class="props.errorMessage && 'error'"
        :type="props.type"
        ref="input"
        :id="`${props.id ? props.id : 'textfield--' + props.name}`"
        :name="`textfield--${props.name}`"
        :placeholder="props.placeholder"
        :tooltip="props.tooltip"
        :value="value"
        :maxLength="props.maxLength"
        :max="max"
        :min="min"
        :dirty="props.dirty"
        :autocomplete="autocomplete"
        @input="$emit('update:value', $event.target.value)"
      />
      <small v-if="props.errorMessage" class="error-message">
        {{ props.errorMessage }}
      </small>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.text-field {
  display: block;
  position: relative;
  text-align: left;

  &:hover {
    .tooltip {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.2s ease-in-out;
    }
  }
}

.tooltip {
  position: absolute;
  right: 0;
  visibility: hidden;
  background-color: rgb(0 0 0 / 80%);
  padding: 0.25rem;
  color: $AC_White;
  border-radius: 4px;
  font-size: 12px;
  margin-top: -2rem;

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 80%;
    width: 0;
    height: 0;
    border-top: 8px solid rgb(0 0 0 / 80%);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
  }
}

.input-field {
  display: block;
  padding: 0.25rem 0.75rem;
  width: 100%;
  height: 52px;
  background-color: #f3f3f3;
  border-radius: 4px;
  border: 2px solid #cdcdcd;

  &.error,
  &.error:focus {
    border-color: $AC_Primary;
  }
}

.error-message {
  color: $AC_Primary;
}
</style>
